import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=10268db7&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10268db7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10268db7')) {
      api.createRecord('10268db7', component.options)
    } else {
      api.reload('10268db7', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=10268db7&scoped=true&", function () {
      api.rerender('10268db7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UuS2KR37x3xe/JS/comp/Accordion.vue"
export default component.exports